import { IResult } from 'slipstream-components';

export default async function convertSingleServiceResult(
  result: Promise<IResult>,
  entityType: string
) {
  const r = await result;
  const body = r.body;
  return body[entityType];
}
